module.exports = __webpack_public_path__ + "media/images/sites/health/bg-footer-8a8fc6d370e20ace7ec42ec329b32d93.png";